import api from '@/services/APIService';

class ReportsService {
    async getEvents() {
        return await api.fetch({ method: 'get', path: 'promoter/event' });
    }
    async getEventsHasRaces() {
        return await api.fetch({ method: 'get', path: 'promoter/event/hasraces' });
    }
    async getRacesForEvent(eventId) {
        return await api.fetch({ method: 'get', path: `promoter/event/${eventId}/races` });
    }
    async getRockyMountainReport(data) {
        return await api.fetch({ method: 'post', path: 'promoter/reports/events/race/participant', data });
    }
}

export default new ReportsService();
